module.exports = __webpack_public_path__ + "img/thai-curry-1.0e65a6ab.jpg";